import { StyleProvider } from '@ant-design/cssinjs'
import { Auth0Provider } from '@auth0/auth0-react'
import { Loading } from '@salescore/client-common'
import { ConfigProvider } from 'antd'
import en_US from 'antd/es/locale/en_US'
import ja_JP from 'antd/es/locale/ja_JP'
import i18n from 'i18next'
import { type ReactElement, Suspense, useEffect, useState } from 'react'

// hydrationを無効化する
const SafeHydrate = ({ children }: { children: ReactElement }): ReactElement => {
  const [visibility, setVisibility] = useState(false)
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisibility(true)
  }, [])

  if (!visibility) {
    return <></>
  }

  return <>{children}</>
}

// ブラウザのデフォルトのショートカットキーを無効にする
const GlobalShortcutGuard = ({ children }: { children: ReactElement }): ReactElement => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault()
      }
    }
    globalThis.addEventListener('keydown', onKeyDown)
    return () => {
      globalThis.removeEventListener('keydown', onKeyDown)
    }
  }, [])

  return <>{children}</>
}

export const DefaultProvider = ({ children }: { children: ReactElement }): ReactElement => (
  <SafeHydrate>
    <GlobalShortcutGuard>
      <Suspense fallback={<Loading />}>
        <Auth0Provider
          domain={process.env.AUTH0_DOMAIN}
          clientId={process.env.AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: globalThis.location.origin,
          }}
        >
          <StyleProvider>
            <ConfigProvider
              button={{ autoInsertSpace: false }}
              locale={i18n.language === 'en' ? en_US : ja_JP}
              theme={{
                token: {
                  colorPrimary: `#376DF8`,
                  borderRadius: 6,
                  colorBgLayout: `#F9FBFD`,
                  fontFamily: [
                    `-apple-system`,
                    'system-ui',
                    'Segoe UI',
                    `roboto`,
                    'Helvetica Neue',
                    `helvetica`,
                    `arial`,
                    `sans-serif`,
                  ].join(', '),
                  // colorBgBase: `#FDFEFF`,
                  // 'table-body-sort-bg': '#FEFBEA', // bg-yellow-100
                  // 'table-row-hover-bg': 'white',
                  // // "table-padding-horizontal": "8px",
                  // // "table-padding-vertical": "8px",
                },
              }}
            >
              {children}
            </ConfigProvider>
          </StyleProvider>
        </Auth0Provider>
      </Suspense>
    </GlobalShortcutGuard>
  </SafeHydrate>
)
